import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/emailVerification/messages";

function* verifyEmail(action) {
  const { token } = action.payload;
  const { success, data, error } = yield* makeRequest.post(
    "/email_verification/verify",
    { token },
    { no401redirect: true, noEmailVerifiedRedirect: true },
  );

  if (success && data) {
    yield put(actions.setVerifyEmailStatus("success"));
    yield put(
      actions.newSuccessEvent({
        message: messages.VERIFY_EMAIL_SUCCESS,
        payload: {
          event: messages.VERIFY_EMAIL_SUCCESS_EVENT,
        },
      }),
    );
  } else if (error) {
    if (error.field === "stripe") {
      yield put(actions.setVerifyStripeError(error.message || messages.VERIFY_EMAIL_STRIPE_ERROR));
      yield put(actions.setVerifyEmailStatus("stripe_error"));
      return getErrorActions({ error });
    }
    if (error.message === messages.VERIFY_EMAIL_EXPIRED) {
      yield put(actions.setVerifyEmailStatus("expired"));
      return getErrorActions({
        error: {
          ...error,
          event: messages.VERIFY_EMAIL_EXPIRED_EVENT,
        },
      });
    }
    yield put(actions.setVerifyEmailStatus("invalid"));
    return getErrorActions({
      error: {
        ...error,
        event: messages.VERIFY_EMAIL_INVALID_EVENT,
      },
    });
  }

  return null;
}

export default verifyEmail;
